import AmioHttpService from '@/services/amio/amio-http.service'

// Qdrant collection registry (PRO-184), gated by verifyAdmin on the engine.
// READ-ONLY since PRO-635: the registry is derived state — the indexer provisions each organization's
// collection and elects its filterable fields — so there is nothing here to write.
class VectorCollectionService extends AmioHttpService {
  async list() {
    try {
      const response = await this.requestGet('/vector-collections')
      return response.data
    } catch (err) {
      throw this.handleError(err)
    }
  }

  // The SSOT-locked vector geometry (size/distance), for display
  async getIndexSchema() {
    try {
      const response = await this.requestGet('/vector-collections/index-schema')
      return response.data
    } catch (err) {
      throw this.handleError(err)
    }
  }
}

export default new VectorCollectionService()
